// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__1wpFG","description":"PatientConsentPreview_description__2nBct"};